module.exports = __webpack_public_path__ + "img/eccezzioni_smartbook.9b9c729d.png";